import { render, staticRenderFns } from "./NgTextarea.vue?vue&type=template&id=d2118d80"
import script from "./NgTextarea.vue?vue&type=script&lang=js"
export * from "./NgTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports